<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-01 10:08:40
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-13 18:28:53
-->
<template>
  <div class="x-check-box">
    <el-checkbox v-if="showCheckAll" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
      全选
    </el-checkbox>
    <el-checkbox-group v-model="checkList" @change="handleCheckedChange">
      <el-checkbox
        v-for="(item, index) in listData"
        :key="index"
        :label="item[propObject.value]"
        :disabled="!!item.disabled"
      >
        {{ item[propObject.label] }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<script>
  export default {
    name: 'XCheckBox',
    model: {
      prop: 'result',
      event: 'handleResult'
    },
    props: {
      showCheckAll: {
        type: Boolean,
        default: false
      },
      listData: {
        type: Array,
        default: () => []
      },
      propObject: {
        type: Object,
        default: () => {
          return { label: 'label', value: 'value' }
        }
      },
      result: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        checkList: [],
        checkAll: false,
        isIndeterminate: true
      }
    },
    computed: {
      getResult() {
        return JSON.stringify(this.result)
      }
    },
    watch: {
      getResult(newValue) {
        if (newValue !== JSON.stringify(this.checkList)) {
          this.checkList = this.result
        }
      }
    },
    mounted() {
      this.checkList = this.result
    },
    methods: {
      handleResult() {
        this.$emit('handleResult', this.checkList)
      },
      handleCheckedChange(value) {
        const checkedCount = value.length
        this.checkAll = checkedCount === this.listData.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.listData.length
        this.$emit('handleResult', this.checkList)
      },
      handleCheckAllChange(val) {
        this.checkList = val ? this.listData : []
        this.isIndeterminate = false
        this.$emit('handleResult', this.checkList)
      }
    }
  }
</script>
